import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { disableShareScreenModeration, enableShareScreenModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from './slice';
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the screen-sharing moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.SHARE_SCREEN_MODERATION_APPROVED, ({ requestOccupantJid }) => {
            dispatch(localParticipantApproved());
        });
        conference.on(JitsiConferenceEvents.SHARE_SCREEN_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        conference.on(JitsiConferenceEvents.SHARE_SCREEN_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled ? dispatch(enableShareScreenModeration(actor)) : dispatch(disableShareScreenModeration(actor));
        });
        conference.on(JitsiConferenceEvents.SHARE_SCREEN_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantApproved({ jid }));
        });
        conference.on(JitsiConferenceEvents.SHARE_SCREEN_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
    }
});
